import * as React from "react";
import {
  BODetailTopBar,
  BODetailTopBarItem,
} from "app/components/BOComponents/BODetailTopBar/BODetailTopBar";

const ApplicationStatusMessagesGeneralTopBar = () => {
  return (
    <BODetailTopBar>
      <BODetailTopBarItem
        text="Active Status Messages"
        link={`/snapscan/ops/application_status_messages/active`}
      />
      <BODetailTopBarItem
        text="Status Messages"
        link={`/snapscan/ops/application_status_messages/list`}
      />
      <BODetailTopBarItem
        text="Add New Status Message"
        link={`/snapscan/ops/application_status_messages/create`}
      />
    </BODetailTopBar>
  );
};

export default ApplicationStatusMessagesGeneralTopBar;
